import { makeStateKey } from '@angular/core';
import { Story } from './blog.types';

export const ARTICLES_STATE_KEY = makeStateKey<Story[]>('ARTICLES');
export const STORYBLOK_API =
  'https://api.storyblok.com/v2/cdn/stories?version={{version}}&starts_with=blog%2F&token={{api_key}}';
